import { render, staticRenderFns } from "./z_wechat_attention.vue?vue&type=template&id=04ffb253&scoped=true&"
import script from "./z_wechat_attention.vue?vue&type=script&lang=js&"
export * from "./z_wechat_attention.vue?vue&type=script&lang=js&"
import style0 from "./z_wechat_attention.vue?vue&type=style&index=0&id=04ffb253&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ffb253",
  null
  
)

export default component.exports